import { css } from '@emotion/css';
import { useNavigate, A } from '@solidjs/router';
import { IgnorePageMarginsStyle } from 'Shared/frontend/IgnorePageMarginsStyle';
import { SubNav, jumpToAnchor } from 'Shared/frontend/SubNav';
import { theme } from 'Shared/frontend/SettingsProvider';
import { buttonCss, subNavButtonCss } from 'Shared/frontend/styles/buttonStyleCss';
import { useInsideLink } from 'Shared/frontend/widgets/InsideLinkContext';
import { Switch, Match, For } from 'solid-js';


const stickyStyle = () => css({
	position: 'sticky',
	top: '0',
	zIndex: '10',

	/* NOTE equal to SubNav innerStyle() margins. Unfortunately we either have collapsing margins OR stickiness it seems. */
	marginTop: '-32px', 
	marginBottom: '-32px', 
});

//TODO hover
//const stickyNavButtonStyle = () => css(theme().widgets.subNav.button);

const buttonStyle = (isNav:boolean) => isNav
	? css({...theme().widgets.subNav.button, ...subNavButtonCss()})
	: css({...theme().button, ...buttonCss()});

const plainStyle = () => css({
	marginTop: '2em',
	marginBottom: '2em'
});


export function Buttons(P)
{
	let stickyNode!: HTMLElement;

	//NOTE with sticky the section loses its vertical margins. The SubNav provides its own.

	return (
		<Switch>
			<Match when={P.isNav}>
				<div ref={stickyNode} class={css(P.sticky && stickyStyle(), P.sticky.css)}>
					<IgnorePageMarginsStyle disable={!P.sticky}>
						<SubNav>
							<ButtonList {...P} />
						</SubNav>
					</IgnorePageMarginsStyle>
				</div>
			</Match>
			<Match when={true}>
				<div class={css(plainStyle(), P.styling?.css)}>
					<ButtonList {...P} />
				</div>
			</Match>
		</Switch>
	);
}

function ButtonList(P)
{
	const navigate = useNavigate();
	const insideLink = useInsideLink();

	const handleClick = item => {
		if (item.openInSameWindow) { 	//TODO improve name
			/*
				Route through the router (rather than assigning document.location) so that same-page
				anchor jumps don't trigger the page-fade in OuterPage's useBeforeLeave handler, which
				would otherwise leave <body> stuck at opacity 0.
			*/
			jumpToAnchor(navigate, item.link);
		}
		else
			window.open(item.link, '_blank')?.focus();
	}

//TODO move the gDriveDownloadAsPDF stuff into handleClick()	

	return (
		<For each={P.buttons}>{item =>
			<Switch>
				{/* An anchor inside an anchor is invalid HTML and breaks hydration: cf InsideLinkContext */}
				<Match when={insideLink()}>
					<button class={buttonStyle(P.isNav)}>
						{item.text ?? 'Button'}
					</button>
				</Match>

				{/* Sanity check if google doc url doesn't contain /edit?usp=sharing we can't convert it to a PDF */}
				<Match when={
					item.gDriveDownloadAsPDF &&
					item.link?.includes('google.com/document/') && 
					item.link?.includes('/edit?usp=sharing') 
				}>
					<a href={item.link.replace('/edit?usp=sharing','/export?format=pdf')} target='_blank'>
						<button class={buttonStyle(P.isNav)}>
							{item.text ?? 'Button'}
						</button>
					</a>
				</Match>
				<Match when={true}>
					<A href={item.link ?? ''} target={!item.openInSameWindow ? '_blank' : undefined}>
						<button class={buttonStyle(P.isNav)}>
							{item.text ?? 'Button'}
						</button>
					</A>
				</Match>
			</Switch>
		}</For>
	);
}

